import { Controller } from '@hotwired/stimulus'

const getHeightDot = (navigation) => {
  const dot = navigation.children[0]
  const height = dot.clientHeight
  const style = getComputedStyle(dot)
  const marginTop = parseInt(style.marginTop)
  const marginBottom = parseInt(style.marginBottom)

  return height + marginTop + marginBottom
}

const CreateCarouselNavigation = (container, sliders) => {
  const navigation = document.createElement('ul')

  const createNavigation = () => {
    navigation.className = 'grid transition-all duration-300 ease-in'
    container.appendChild(navigation)
  }

  const createDots = () => {
    sliders.forEach(() => {
      const dot = document.createElement('li')
      dot.className = 'my-1 w-2.5 h-2.5 rounded-full transition-all duration-300 ease-in scale-50 bg-white/60'
      navigation.appendChild(dot)
    })
  }

  const updateContainer = () => {
    const value = getHeightDot(navigation) * 5 // 5 dots is visible
    container.style.maxHeight = `${value}px`
  }

  createNavigation()
  createDots()
  updateContainer()

  return navigation
}

class CarouselNavigate {
  constructor (sliders, navigation) {
    this.sliders = sliders
    this.navigation = navigation
    this.dots = Array.from(navigation.children)
  }

  intersected (slider) {
    this.setInactiveDots()
    this.setActiveDot(this.currentSliderIndex(slider))
    this.setActiveNearDot(this.currentSliderIndex(slider) + 1)
    this.setActiveNearDot(this.currentSliderIndex(slider) - 1)
    this.updateNavigation(this.currentSliderIndex(slider))
  }

  setInactiveDots () {
    this.dots.forEach(dot => {
      dot.classList.remove('bg-white', 'scale-100', 'scale-75')
      dot.classList.add('bg-white/60', 'scale-50')
    })
  }

  setActiveDot (index) {
    this.dots[index].classList.remove('bg-white/60', 'scale-75', 'scale-50')
    this.dots[index].classList.add('bg-white', 'scale-100')
    this.dots[index].setAttribute('isCurrent', 'true')
  }

  setActiveNearDot (index) {
    this.dots[index]?.classList.remove('scale-50')
    this.dots[index]?.classList.add('scale-75')
    this.dots[index]?.removeAttribute('isCurrent')
  }

  updateNavigation (index) {
    if ((index > 1) && (this.dots.length - index) > 2) {
      const value = (getHeightDot(this.navigation) * 2) - (index * getHeightDot(this.navigation))
      this.navigation.style.transform = `translateY(${value}px)`
    }
  }

  currentSliderIndex (slider) {
    return this.sliders.findIndex(s => s === slider)
  }
}

export class NavigationComposableController extends Controller {
}

export const useCarouselNavigation = (composableController, container, sliders) => {
  const controller = composableController

  const controllerDisconnect = controller.disconnect.bind(controller)

  const navigation = CreateCarouselNavigation(container, sliders)
  const navigate = new CarouselNavigate(sliders, navigation)

  const intersected = (slider) => {
    navigate.intersected(slider)
  }

  const dots = navigate.dots

  Object.assign(controller, {
    intersected,
    dots,
    disconnect () {
      controllerDisconnect()
    }
  })
}
